(function ($) {
  Drupal.behaviors.spp = {
    attach: function (context, settings) {
      var productData = page_data['catalog-spp']['products'][0];
      // setup carousel
      var $productImages = $('.spp-product__images');
      var $productImage = $('img', $productImages);
      var $productImageCount = $productImage.length;

      $productImage.each(function (index, val) {
        var smooshCheck = $(this).attr('src').indexOf('smoosh');

        if (smooshCheck > 1) {
          $(this).parent().addClass('smoosh');
        }
      });
      if ($productImageCount > 1) {
        $('.spp-product__images').slick({
          dots: true,
          arrows: false,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1
        });

        $productImages.on('sku:select', function (e, skuData) {
          var newImageArray = [];

          newImageArray = skuData.MEDIUM_IMAGE;
          var newSmoosh = skuData.XS_SMOOSH;

          newImageArray.splice(1, 0, newSmoosh);
          // getting odd duplicate, make unique
          newImageArray = _.uniq(newImageArray);
          // current slide count
          var slideCount = $('.spp-product__images .slick-dots li').length;

          // create new list
          for (var i = slideCount - 1; i >= 0; i--) {
            $('.spp-product__images').slick('slickRemove', i);
          }
          $(newImageArray).each(function (index, val) {
            // add smoosh class
            var smooshClass = val.indexOf('smoosh') > 1 ? 'smoosh' : '';
            // add slide
            var newSlide =
              '<div class="spp-product__image ' + smooshClass + '"><img src="' + val + '" /></div>';

            $('.spp-product__images').slick('slickAdd', newSlide);
          });
        });
      }

      // shaded
      if (productData.shaded) {
        // shade picker
        var sppPicker = new site.ShadePicker(productData);
        var smooshSlider = new site.SmooshSlider({
          containerNode: $('.smoosh-list'),
          productData: productData
        });
        // get SKU Base ID from url and change shade based on that
        var skuBaseIDfromURL = window.location.hash.substr(1);

        if (skuBaseIDfromURL !== undefined && skuBaseIDfromURL.length > 0) {
          var skuShadeName = skuBaseIDfromURL.replace('/shade/', '').replace('-', ' ');
          var skuDataFromURL = _.find(productData.skus, function (sku) {
            return sku.SHADENAME === skuShadeName;
          });

          if (!!skuDataFromURL && !!skuDataFromURL.SKU_BASE_ID) {
            $productImages.trigger('sku:select', skuDataFromURL);
            sppPicker.updateSwatches(skuDataFromURL.SKU_BASE_ID);
            sppPicker.updateSelects(skuDataFromURL.SKU_BASE_ID);
          }
        }
      }
      site.addFavoritesButton($('.js-add-to-favorites'));

      // start closed
      $('.spp-product__additional-section').addClass('is_closed');

      $('.spp-product__additional-section-button').click(function (event) {
        event.preventDefault();
        $(this).parent('.spp-product__additional-section').toggleClass('is_closed');
      });

      $('.spp-product__detail-link').click(function (event) {
        var headerOffset = $('.page-header').outerHeight();

        event.preventDefault();

        $('.spp-product__details')
          .closest('.spp-product__additional-section')
          .removeClass('is_closed');

        $('html, body').animate(
          {
            scrollTop: $('.spp-product__details').offset().top - headerOffset
          },
          'slow'
        );
      });

      var $quantitySelect = $('.spp-product__quantity');
      var $sizeSelect = $('.spp-product__price-size-select');
      var $skintypeSelect = $('.spp-product__skintype-select');

      // size select init:

      // get skus to show from skintype
      // if size exists
      if ($sizeSelect.length && $skintypeSelect.length) {
        function updateSizeSelect() {
          $('option', $sizeSelect).prop('disabled', true);
          var selectedSkus = $skintypeSelect.find('option:selected').attr('data-skus').split(',');

          $(selectedSkus).each(function (index, val) {
            $('option', $sizeSelect)
              .filter('[data-sku-base-id=' + val + ']')
              .prop('disabled', false);
          });
          var $sizeSelectClone = $sizeSelect.clone();

          $sizeSelectClone.removeClass('reference');
          if ($('.sizeSelectClone').length) {
            $('.sizeSelectClone').remove();
          }
          $sizeSelectClone.addClass('sizeSelectClone');
          $('option:disabled', $sizeSelectClone).remove();
          $sizeSelect.parent().append($sizeSelectClone);

          $('.sizeSelectClone').on('change', function (event) {
            var selectedSku = $(this).find('option:selected').attr('data-sku-base-id');
            // console.log(selectedSku);
            var skuData = _.find(productData.skus, function (sku) {
              return sku.SKU_BASE_ID == selectedSku;
            });

            site.skuSelect(skuData);
          });
          $('.sizeSelectClone').trigger('change');
        }
        updateSizeSelect();
        // $sizeSelect.selectBox();
      } else if ($sizeSelect.length && !$skintypeSelect.length) {
        $sizeSelect.removeClass('reference');
        $sizeSelect.on('change', function () {
          var selectedSku = $(this).find('option:selected').attr('data-sku-base-id');
          // console.log(selectedSku);
          var skuData = _.find(productData.skus, function (sku) {
            return sku.SKU_BASE_ID == selectedSku;
          });

          site.skuSelect(skuData);
        });
      }

      $quantitySelect.on('change', function (event) {
        var quantity = $(this).val();

        site.qtySelect(productData.PRODUCT_ID, quantity);
      });

      // only use skintype as reference, set sku from size select
      $skintypeSelect.on('change', function (event) {
        updateSizeSelect();
        if ($sizeSelect.length) {
          updateSizeSelect();
        } else {
          var selectedSku = $(this).find('option:selected').attr('data-skus');
          // console.log(selectedSku);
          var skuData = _.find(that.productData.skus, function (sku) {
            return sku.SKU_BASE_ID == selectedSku;
          });

          site.skuSelect(skuData);
        }
      });
      // Personalization SPP initialization
      if (Drupal.ELB.hasPersonalization()) {
        if (site.profile.mobile && site.profile.mobile.SPP) {
          site.profile.mobile.SPP(page_data['catalog-spp']);
        }
      }
      if (Drupal.settings.globals_variables.enable_deep_link) {
        if (
          !page_data ||
          !page_data['catalog-spp'] ||
          !Array.isArray(page_data['catalog-spp']['products'])
        ) {
          return null;
        }
        var productData = page_data['catalog-spp']['products'][0];

        if (productData.shaded) {
          var sppPicker = new site.ShadePicker(productData);

          sppPicker.shadeInit();
        }
      }
    } // attach
  };
})(jQuery);
